import useEnv from '@zenbusiness/application-commons-env';
import Button from '@zenbusiness/zui/Button';
import Card from '@zenbusiness/zui/Card';
import CardContent from '@zenbusiness/zui/CardContent';
import Center from '@zenbusiness/zui/Center';
import Grid from '@zenbusiness/zui/Grid';
import PageContainer from '@zenbusiness/zui/PageContainer';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './AccountNotFound.style';

const homepageUrl = '/';
const troubleshootingUrl = 'https://help.zenbusiness.com/en/articles/8583828-troubleshooting-the-zenbusiness-dashboard';
const contactUsUrl = '/contact-us';

const AccountNotFound = () => {
  const {
    AUTH_PATHS: { loginUri },
  } = useEnv('head-first');

  return (
    <PageContainer>
      <Center p={2}>
        <Styled.GridContainer>
          <Grid item>
            <SharedAsset alt="Account not found" height={118} src="/icon/product/no-documents.svg" width={128} />
          </Grid>
          <Grid item>
            <Styled.ContentHeader
              title="We can't find this account"
              subtitle="We couldn't sign you in with the info you provided. Let's get you back on track."
            />
          </Grid>
          <Grid item>
            <Styled.NewAccountCard>
              <CardContent>
                <Styled.SectionHeading>Are you new here?</Styled.SectionHeading>
                Welcome! You need to create an account, so go to our{' '}
                <Styled.InlineLink
                  clickstreamProps={{
                    elementName: 'account_not_found_link',
                    elementText: 'Homepage',
                    linkDestination: homepageUrl,
                  }}
                  href={homepageUrl}
                >
                  homepage
                </Styled.InlineLink>{' '}
                to get started.
              </CardContent>
            </Styled.NewAccountCard>
            <Card>
              <CardContent>
                <Styled.SectionHeading>Already have an account with ZenBusiness?</Styled.SectionHeading>
                <Styled.ListWithLessPadding>
                  <li>
                    If you created a <b>password</b> for your account, return to the login page and enter your account
                    email and password.
                  </li>
                  <li>
                    If you authorized <b>Sign In with Google</b> or <b>Sign in with Apple</b>, confirm which account you
                    used to connect to ZenBusiness and try again.
                  </li>
                </Styled.ListWithLessPadding>
              </CardContent>
            </Card>
          </Grid>
          <Grid item>
            <Text size="xs" align="center">
              Not sure which one you have? Check out{' '}
              <Styled.InlineLink
                clickstreamProps={{
                  elementName: 'account_not_found_link',
                  elementText: 'Login Troubleshooting',
                  linkDestination: troubleshootingUrl,
                }}
                href={troubleshootingUrl}
              >
                Login Troubleshooting
              </Styled.InlineLink>{' '}
              or{' '}
              <Styled.InlineLink
                clickstreamProps={{
                  elementName: 'account_not_found_link',
                  elementText: 'Contact Us',
                  linkDestination: contactUsUrl,
                }}
                href={contactUsUrl}
              >
                Contact Us
              </Styled.InlineLink>{' '}
              for help.
            </Text>
          </Grid>
          <Grid item>
            <Button
              clickstreamProps={{
                elementName: 'account_not_found_button',
                elementText: 'Return to login',
                linkDestination: loginUri,
              }}
              href={loginUri}
              size="lg"
            >
              Return to login page
            </Button>
          </Grid>
        </Styled.GridContainer>
      </Center>
    </PageContainer>
  );
};

export default AccountNotFound;
